export var wrapper = 'w-full flex flex-row justify-center items-center';
export var paginationItem = 'p-1 border border-textLight rounded-full mr-1 bg-textLight';
export var activePaginationItem = "p-1 rounded-full mr-1 bg-pink-500 border-none w-6 h-2";
export var visitedItem = 'p-1 border border-pink-300 rounded-full mr-1 bg-pink-300';
//# sourceMappingURL=slider-pagination.styles.js.map